/**
 * Employee Service
 * Handles employee-related API calls including hierarchy issue reporting
 */

import { apiService } from './api';
import { authService } from './authService';

export interface ReportIssueRequest {
  tag: string;
  remarks: string;
  email?: string;
  employee_email?: string;
  manager_email?: string;
}

export interface ReportIssueResponse {
  status: boolean;
  message?: string;
  error?: string;
}

class EmployeeService {
  /**
   * Report email or hierarchy issue
   */
  async reportEmailIssue(remarks: string): Promise<ReportIssueResponse> {
    try {
      console.log('🔄 EmployeeService - Reporting email issue with remarks:', remarks);
      
      const requestData: ReportIssueRequest = {
        tag: 'email_issue',
        remarks: remarks
      };

      const response = await apiService.post('/api/v1/employee/mail/', requestData);
      
      console.log('✅ EmployeeService - Email issue reported successfully:', response);
      
      return {
        status: true,
        message: (response.data as any)?.message || 'Issue reported successfully',
      };
    } catch (error: any) {
      console.error('❌ EmployeeService - Error reporting email issue:', error);
      
      return {
        status: false,
        error: error.response?.data?.message || error.message || 'Failed to report issue'
      };
    }
  }

  /**
   * Report issue with specific type prefix
   */
  async reportIssueWithType(
    issueType: 'hierarchy' | 'not_you',
    userRemarks: string,
    employeeEmail?: string,
    managerEmail?: string,
  ): Promise<ReportIssueResponse> {
    try {
      let tagValue = '';
      
      if (issueType === 'hierarchy') {
        tagValue = 'Report Issue in Hierarchy';
      } else if (issueType === 'not_you') {
        tagValue = 'Email Issue NOT YOU';
      }
      console.log('🔄 EmployeeService - Reporting issue with type:', issueType);
      console.log('🔄 EmployeeService - Tag:', tagValue);
      console.log('🔄 EmployeeService - User remarks:', userRemarks);
      
      const currentUser = authService.getStoredUser();
      const userEmail = currentUser?.email;
      
      const requestData: ReportIssueRequest = {
        tag: tagValue,
        remarks: userRemarks,
        email: userEmail,
        ...(employeeEmail && { employee_email: employeeEmail }),
        ...(managerEmail && { manager_email: managerEmail }),
      };

      const response = await apiService.post('/api/v1/employee/mail/', requestData);
      
      console.log('✅ EmployeeService - Issue reported successfully:', response);
      
      return {
        status: true,
        message: (response.data as any)?.message || 'Issue reported successfully',
      };
    } catch (error: any) {
      console.error('❌ EmployeeService - Error reporting issue:', error);
      
      return {
        status: false,
        error: error.response?.data?.message || error.message || 'Failed to report issue'
      };
    }
  }
}

export const employeeService = new EmployeeService();
export default employeeService;
